import { render, staticRenderFns } from "./ForgetPass.vue?vue&type=template&id=7a8e1138&scoped=true&"
import script from "./ForgetPass.vue?vue&type=script&lang=js&"
export * from "./ForgetPass.vue?vue&type=script&lang=js&"
import style0 from "./ForgetPass.vue?vue&type=style&index=0&id=7a8e1138&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8e1138",
  null
  
)

export default component.exports